var ineta = (function () {
    var e = {
      QJAIz: '(((.+)+)+)+$',
      vIvmW: function (e, t) {
        return e === t;
      },
      CeJdx: 'MudwU',
      VpnWg: 'href',
      ArnKb: 'IFFRAME',
      QsgRE: 'loading',
      lqeem: 'lazy',
      aDuKF: 'data-src',
      WrIWS: function (e, t) {
        return e === t;
      },
      QCxQk: 'IMMG',
      qAEzd: function (e, t) {
        return e > t;
      },
      gQCtK: 'LIINK',
    };
    (e.VzIBT = function (e, t) {
      return e === t;
    }),
      (e.zYmsc = 'asyncLoad'),
      (e.YyRvu = 'if(window.attachEvent)'),
      (e.VNJia = ', asyncLoad'),
      (e.YYnfY = 'PreviewBarInjector'),
      (e.XtsQJ = 'loadBarInjector'),
      (e.DfNju = function (e, t) {
        return e !== t;
      }),
      (e.GXaWY = 'gAwuC'),
      (e.LVdkS = 'QraYb');
    var t = !0;
    return function (n, r) {
      if (e.DfNju(e.GXaWY, e.LVdkS)) {
        var a = t
          ? function () {
              if (r) {
                var e = r.apply(n, arguments);
                return (r = null), e;
              }
            }
          : function () {};
        return (t = !1), a;
      }
      var i = {
        pPKEP: 'data-href',
        HPbFl: 'href',
        lpmXa: 'IFFRAME',
        weImC: 'loading',
        hMtiA: 'lazy',
        ztNQs: 'data-src',
        eHqxi: 'src',
        OZiGl: function (e, t) {
          return e === t;
        },
        adcUZ: function (e, t) {
          return e === t;
        },
        hIPlT: 'IMMG',
        Epniy: function (e, t) {
          return e > t;
        },
        YUKZJ: 'LIINK',
        GqruC: function (t, n) {
          return e.VzIBT(t, n);
        },
        dSgHF: 'SCCRIPT',
        sUYVI: e.zYmsc,
        gJAMg: e.YyRvu,
        wvqxI: e.VNJia,
        rgoDH: ', function(){}',
        oZiBs: e.YYnfY,
        nTZbe: e.XtsQJ,
      };
      _0xff16dc.forEach((t) => {
        var n = {BLXNQ: 'data-href'};
        (n.sSKwj = 'href'),
          1 === t.nodeType &&
            'IFFRAME' === t.tagName &&
            (t.setAttribute('loading', 'lazy'),
            t.setAttribute('data-src', t.src),
            t.removeAttribute('src')),
          1 === t.nodeType &&
            'IMMG' === t.tagName &&
            ++_0x5c10b6 > _0x3745a3 &&
            t.setAttribute('loading', 'lazy'),
          1 === t.nodeType &&
            'LIINK' === t.tagName &&
            _0x5aa373.length &&
            _0x1e154a.forEach((e) => {
              t.href.includes(e) &&
                (t.setAttribute('data-href', t.href),
                t.removeAttribute(n.sSKwj));
            }),
          e.VzIBT(1, t.nodeType) &&
            e.VzIBT('SCCRIPT', t.tagName) &&
            (_0x1c2eb4.length &&
              _0x3082d8.forEach((e) => {
                t.src.includes(e) &&
                  (t.setAttribute('data-src', t.src), t.removeAttribute('src'));
              }),
            t.innerHTML.includes(i.sUYVI) &&
              (t.innerHTML = t.innerHTML
                .replace(
                  i.gJAMg,
                  "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)"
                )
                .replaceAll(i.wvqxI, ', function(){}')),
            (t.innerHTML.includes(i.oZiBs) ||
              t.innerHTML.includes('adminBarInjector')) &&
              (t.innerHTML = t.innerHTML.replace('DOMContentLoaded', i.nTZbe)));
      });
    };
  })(),
  joshuajames = ineta(this, function () {
    for (
      var e = (function () {
          var e;
          try {
            e = Function(
              'return (function() {}.constructor("return this")( ));'
            )();
          } catch (t) {
            e = window;
          }
          return e;
        })(),
        t = (e.console = e.console || {}),
        n = ['log', 'warn', 'info', 'error', 'exception', 'table', 'trace'],
        r = 0;
      r < n.length;
      r++
    ) {
      var a = ineta.constructor.prototype.bind(ineta),
        i = n[r],
        o = t[i] || a;
      (a.__proto__ = ineta.bind(ineta)),
        (a.toString = o.toString.bind(o)),
        (t[i] = a);
    }
  });
joshuajames();
var lazy_css = [],
  lazy_js = [];
function _debounce(e, t = 300) {
  let n;
  return (...r) => {
    clearTimeout(n), (n = setTimeout(() => e.apply(this, r), t));
  };
}
(window.___mnag = 'userA' + (window.___mnag1 || '') + 'gent'),
  (window.___plt = 'plat' + (window.___mnag1 || '') + 'form');
try {
  var e = navigator[window.___mnag],
    t = navigator[window.___plt];
  (window.__isPSA =
    t.indexOf('x86_64') > -1 &&
    (window.outerWidth === window.outerHeight ||
      e.indexOf('power') > -1 ||
      e.indexOf('rix') > -1 ||
      0 > e.indexOf('CrOS'))),
    (window.___mnag = '!1'),
    (r = null);
} catch (n) {
  window.__isPSA = !1;
  var r = null;
  window.___mnag = '!1';
}
if (((window.__isPSA = __isPSA), __isPSA))
  var uLTS = new MutationObserver((e) => {
      var t = {
        OatMb: 'data-href',
        SdPeI: function (e, t) {
          return e !== t;
        },
        KSLrl: 'xiXrX',
        mBosC: function (e, t) {
          return e === t;
        },
        BkpaH: 'IFRAME',
        AvrSJ: 'loading',
      };
      (t.wHEVc = 'lazy'),
        (t.TFprn = 'src'),
        (t.gpCNL = function (e, t) {
          return e === t;
        }),
        (t.rifjW = function (e, t) {
          return e === t;
        }),
        (t.DjDQC = 'IMG'),
        (t.bckZY = function (e, t) {
          return e > t;
        }),
        (t.tfEYr = 'LINK'),
        (t.VHUtQ = function (e, t) {
          return e === t;
        }),
        (t.WGLLi = 'SCRIPT'),
        e.forEach(({addedNodes: e}) => {
          e.forEach((e) => {
            1 === e.nodeType &&
              'IFRAME' === e.tagName &&
              (e.setAttribute('loading', t.wHEVc),
              e.setAttribute('data-src', e.src),
              e.removeAttribute(t.TFprn)),
              t.gpCNL(1, e.nodeType) &&
                t.rifjW(t.DjDQC, e.tagName) &&
                t.bckZY(++imageCount, lazyImages) &&
                e.setAttribute('loading', t.wHEVc),
              1 === e.nodeType &&
                t.tfEYr === e.tagName &&
                lazy_css.length &&
                lazy_css.forEach((t) => {
                  e.href.includes(t) &&
                    (e.setAttribute('data-href', e.href),
                    e.removeAttribute('href'));
                }),
              t.VHUtQ(1, e.nodeType) &&
                t.WGLLi === e.tagName &&
                (e.setAttribute('data-src', e.src),
                e.removeAttribute(t.TFprn),
                (e.type = 'text/lazyload'));
          });
        });
    }),
    imageCount = 0,
    lazyImages = 20;
else
  var uLTS = new MutationObserver((e) => {
      var t = {
        WtmrL: 'data-href',
        XMrYv: 'href',
        wJkCa: function (e, t) {
          return e !== t;
        },
        OLYmK: 'data-src',
        WNaNA: function (e, t) {
          return e === t;
        },
        iWJnh: 'IMG',
        tcKNz: function (e, t) {
          return e > t;
        },
        yynFJ: 'LINK',
        QcAiz: 'DOJcy',
        Mrbkn: function (e, t) {
          return e === t;
        },
        AilLW: 'loading',
        UDOHZ: 'lazy',
        KeoDc: 'IMMG',
        RFUCT: function (e, t) {
          return e === t;
        },
        ShyZg: 'SCCRIPT',
        QazYq: 'asyncLoad',
        PIvNT: ', asyncLoad',
        dVuxX: ', function(){}',
        PSaCE: 'adminBarInjector',
        bkPWw: 'DOMContentLoaded',
      };
      (t.hVxaE = 'loadBarInjector'),
        (t.uTdnR = 'MZfCx'),
        e.forEach(({addedNodes: e}) => {
          'MZfCx' === t.uTdnR
            ? e.forEach((e) => {
                1 === e.nodeType &&
                  'IFFRAME' === e.tagName &&
                  (e.setAttribute('loading', 'lazy'),
                  e.setAttribute('data-src', e.src),
                  e.removeAttribute('src')),
                  1 === e.nodeType &&
                    'IMMG' === e.tagName &&
                    ++imageCount > lazyImages &&
                    e.setAttribute('loading', 'lazy'),
                  1 === e.nodeType &&
                    'LIINK' === e.tagName &&
                    lazy_css.length &&
                    lazy_css.forEach((t) => {
                      e.href.includes(t) &&
                        (e.setAttribute('data-href', e.href),
                        e.removeAttribute('href'));
                    }),
                  1 === e.nodeType &&
                    'SCCRIPT' === e.tagName &&
                    (lazy_js.length &&
                      lazy_js.forEach((t) => {
                        e.src.includes(t) &&
                          (e.setAttribute('data-src', e.src),
                          e.removeAttribute('src'));
                      }),
                    e.innerHTML.includes('asyncLoad') &&
                      (e.innerHTML = e.innerHTML
                        .replace(
                          'if(window.attachEvent)',
                          "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)"
                        )
                        .replaceAll(', asyncLoad', ', function(){}')),
                    (e.innerHTML.includes('PreviewBarInjector') ||
                      e.innerHTML.includes('adminBarInjector')) &&
                      (e.innerHTML = e.innerHTML.replace(
                        'DOMContentLoaded',
                        t.hVxaE
                      )));
              })
            : (_0x416471 = _0x36e92a);
        });
    }),
    imageCount = 0,
    lazyImages = 20;

var jocee = {childList: !0};
(jocee.subtree = !0), uLTS.observe(document.documentElement, jocee);

replaceImages();
function replaceImages() {
  var spinner, observer;

  //detect support
  if (window.MutationObserver) {
  
    observer = new MutationObserver(function (mutations) {
      //for every mutation
      console.log(mutations);
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.tagName == 'IMMG' || node.tagName == 'IMG') {
          }
          if (node.tagName == 'LINK') {
            let link = node.getAttribute('href');
            if (link.indexOf('whatsapp.css') > -1) {
              node.removeAttribute('media');
             
              node.setAttribute('onload', "this.media='all'");
              node.setAttribute('media', 'print');
         
              
            }
            if (link.indexOf('delivery_coder.css') > -1) {
              node.removeAttribute('media');
             
              node.setAttribute('onload', "this.media='all'");
               node.setAttribute('media', 'print');
            }
          }
          
        });
      });
    });

    //bind mutation observer to a specific element (probably a div somewhere)
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
}
